import { createFileRoute } from '@tanstack/react-router';
import { DirectoryTab } from '@/features/integrations';

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/integrations/all/directory')({
  component: DirectoryTab,
});
